import React from "react";
import useController from "./controller";
import BaseButton from "../../../../components/BaseButton";
import BaseDivider from "../../../../components/BaseDivider";
import BaseIcon from "../../../../components/BaseIcon";
import ElementLoading from "../../../../components/ElementLoading";
import { useTranslation } from "../../../../locales";
import AcademicFields from "../AcademicFields";
import "./style.scss";

export default function AcademicPage() {
  const { onSave, onChange, onDelete, onAdd, loading, processing, educations, setCheckValidation } = useController();
  const { t } = useTranslation();

  return (
    <div className="academic-page">
      {loading ? (
        <ElementLoading loading={loading} />
      ) : (
        <>
          <AcademicFields
            education={educations[0]}
            educationIndex={0}
            onChange={(job) => onChange(job, 0)}
            setCheckValidation={setCheckValidation}
          />
          {educations.slice(1).map((education, index) => {
            index += 1;
            return (
              <div key={index}>
                <BaseDivider className="academic-page__divider" />
                <AcademicFields
                  education={education}
                  educationIndex={index}
                  onDelete={() => onDelete(index)}
                  onChange={(job) => onChange(job, index)}
                  setCheckValidation={setCheckValidation}
                />
              </div>
            );
          })}
          <BaseButton className="academic-page__add-field pa-0 mt-6" opacity onClick={onAdd}>
            <BaseIcon className="mr-1">circle-plus</BaseIcon>
            {t("Add education")}
          </BaseButton>
          <BaseButton className="academic-page__save ml-auto mt-8" loading={processing} large onClick={onSave}>
            {t("Save changes")}
          </BaseButton>
        </>
      )}
    </div>
  );
}
